<script>
    import QuestionLibrary from '../../Models/QuestionLibraryModel';
    import Loader from '../Loader.svelte';
    import SortableTable from '../SortableTable.svelte';
    import { isAdmin } from '../../Utilities/Session.svelte';
    import { addFormModal } from '../../Forms/ModalFormManager.svelte';
    import { notifier } from '@beyonk/svelte-notifications';
    import {confirm} from '../Confirmation.svelte';

    let sortFields = [
        {
            field: "name",
            label: "Library Name"
        }
    ]

    let formFields = [
        {
            name: "name",
            label: "Library Name",
            required: true
        }
    ]

    function addLibrary() {
        addFormModal({
            fields: formFields,
            title: "Add Question Library",
        }).then((data) => {
            QuestionLibrary.createItem(data).then(() => {
                notifier.success("Question Library Created")
            });;
        }).catch(e => {});
    }

    function deleteLibrary(library) {
        confirm(`Are you sure you want to delete ${library.name}?`).then(() => {
            QuestionLibrary.delete(library._id).then(() => {
                notifier.success("Library Deleted");
            });
        });
    }

    let libraries = QuestionLibrary.getList();
</script>

<Loader loading={!$libraries}>
    <div class="container is-fluid">
        <h1 class="title is-1">Question Libraries</h1>
        <SortableTable {sortFields} tableData={$libraries} actionsWidth="{ $isAdmin ? 180 : 100 }">
            <div slot="filterActions">
                {#if $isAdmin}
                <div class="buttons is-right">
                    <button class="button is-success" on:click={addLibrary}>Add Library</button>
                </div>
                {/if}
            </div>
            <div slot="footerActions">
                <div class="buttons footer-buttons">
                    <a class="button" href="#/QuestionLibrary/Tags">Manage Tags</a>
                    {#if $isAdmin }
                        <button class="button is-success" on:click={addLibrary}>Add Library</button>
                    {/if}
                </div>
            </div>
            <div slot="rowActions" class="buttons is-right" let:row={library}>
                {#if $isAdmin}
                    <button class="button is-danger" on:click={() => deleteLibrary(library)}>Delete</button>
                {/if}
                <a class="button is-link" href="#/questionLibrary/{library._id}">Open</a>
            </div>
        </SortableTable>
    </div>
</Loader>

<style>
    .footer-buttons {
        justify-content: space-between;
    }
</style>